
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class OrderInvoiceRequestModel extends Model<OrderInvoiceRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'orderLineIds', type: 'string[]', isArray: true },
		{ name: 'taskActionId', type: 'string' }
	];
	[key: string]: any;
	
	public orderLineIds: string[];
	public taskActionId?: string;
    
	constructor(){
		super();
		this.orderLineIds = [];
		this.taskActionId = undefined;
		
	}
	getProperties(){
		return OrderInvoiceRequestModel.classProperties;
	}
}

